import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';
import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './shared/config/config.service';
// Factory for APP_INITIALIZER
export function configServiceFactory(config: ConfigService) {
  return () => config.load();
}
import {
  ApplicationRef,
  NgModule
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  RouterModule
} from '@angular/router';


import { HotkeyModule } from 'angular2-hotkeys';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoggerModule } from 'ngx-logger';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { Auth } from './shared/auth/auth.service';

// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { ROUTES } from './app.routes';
import { AppState, InternalStateType } from './app.service';
/*
 * Platform and Environment providers/directives/pipes
 */
import { ENV_PROVIDERS } from './environment';
import {
  AlertComponent,
  ConfirmComponent,
  SharedModule
} from './shared';

import { TpaService } from './tpa/shared/tpa.service';
import { UserProfileService } from './shared/user-profile.service';
import { Injector } from '@angular/core';
import { ServiceLocator } from './shared/serviceLocator.injector';
import { LoginComponent } from './login';
import { HomeComponent } from './home';
import { NoContentComponent } from './no-content';

import { TimedDialogService } from './shared/timedDialog.service';
import { SmartTableService } from './shared/smart-table-service';
import { MassiveActionsGuard } from './massive-actions/shared/massive-actions.guard';
import { OfficeGuard } from './office/office.guard';
import { TpaGuard } from './tpa/tpa.guard';
import { HistoryGuard } from './history/history.guard';
import { APP_CONFIG, AppConfig } from './shared/config/app.config';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        NoContentComponent,
        AlertComponent,
        ConfirmComponent,
  // LoaderComponent removed
    ], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(ROUTES, {
            useHash: true,
            preloadingStrategy: PreloadAllModules
        }),
        HotkeyModule.forRoot(),
        LoggerModule.forRoot({ level: 0 }),
  SharedModule,
  NgxSpinnerModule,
  BsDropdownModule.forRoot()], providers: [
        ENV_PROVIDERS,
        APP_PROVIDERS,
        AuthGuard,
        Auth,
        AppState,
        TimedDialogService,
        SmartTableService,
        UserProfileService,
        TpaService,
        ConfigService,
        MassiveActionsGuard,
        OfficeGuard,
        TpaGuard,
        HistoryGuard,
        {
            provide: APP_INITIALIZER,
            useFactory: configServiceFactory,
            deps: [ConfigService],
            multi: true
        },
        // Added APP_CONFIG provider for global DI
        { provide: APP_CONFIG, useValue: AppConfig },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {


}
